export const CONTROLLERS = {
  opus: {
    endpoint: process.env.REACT_APP_API_OPUS || "/api"
  },
  crm: {
    endpoint: process.env.REACT_APP_API_CRM || "/api"
  },
  visits: {
    endpoint: process.env.REACT_APP_API_VISITS || "/api"
  },
  billing: {
    endpoint: process.env.REACT_APP_API_BILLING || "/api"
  },
  configurator: {
    endpoint: process.env.REACT_APP_API_CONFIGURATOR || "/Configurator/api"
  }
}

export const ANONYMOUS_CLIENT = {
  id: 2,
  interactionId: 40000
}

export const UNKNOWN_PARTNER = {
  id: 40000,
  name: "Unknown"
}

export const VALIDATED_OFFER_ID = 11

export const EVENT_ID_RANGES = {
  system: { start: 1, end: 9 }, // no icons and no actions
  configurator: { start: 10, end: 49 }, // link to config
  events: { start: 50 }, // edit in modal
  complaint: { start: 70, end: 75 } // link to complaint
}

export const BANNED_WORDS = {
  anonymousClient: [
    "depassage",
    "de passage",
    "passage",
    "passant",
    "passante",
    "passanten",
    "client",
    "cliente",
    "anonymous",
    "anonyme",
    "visiteur",
    "visiteuse",
    "visitor",
    "xxx",
    "vente",
    "directe",
    "direct"
  ],
  showroom: ["showroom", "showrooms", "gallery", "elite"]
}
